import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FullscreenService {
    isFullscreen = signal(false);

    toggle() {
        this.isFullscreen.update((current) => !current);
    }
}
